module.exports = __webpack_public_path__ + "img/part1.899b9b92.png";